import React, { Fragment } from "react";
import RegistroComponent from "./component/RegistroComponent";
const RegistroPages = () => {

  
    return (
        <Fragment>
            <div className="container">                
                <RegistroComponent />
            </div>
        </Fragment>
    )
}
export default RegistroPages; 